module.exports = __webpack_public_path__ + "img/icon-sort-arrows.db52a21b.svg";